import { Box, Button, makeStyles } from "@material-ui/core";
import { Quote } from "../../../api/Quote/Quote";
import DoneIcon from "@material-ui/icons/Done";
import { colors } from "swyft-react-core";
import { ProductSubscription } from "../../../api/Product/ProductSubscriptionApi";

const QuoteButtonAddSubscription = ({ quote, subscription, onAddSubscription, ...rest }: Props) => {
  const classes = useStyles();

  const onAdd = async function () {
    if (onAddSubscription) {
      await onAddSubscription(subscription);
    }
  };

  const selected = quote.subscriptions?.some((i) => i.productId === subscription.id);

  return (
    <Button
      {...rest}
      onClick={onAdd}
      variant="contained"
      color={selected ? "default" : "secondary"}
      className={selected ? classes.buttonAdded : classes.button}
    >
      <Box pr={selected ? 1 : 0} component="span" alignItems="center">
        {selected && <DoneIcon className={classes.icon} fontSize="small" />}
      </Box>
      {selected ? "Added" : "Add"}
    </Button>
  );
};

export default QuoteButtonAddSubscription;

interface Props {
  quote: Quote;
  subscription: ProductSubscription;
  onAddSubscription: (subscription: ProductSubscription) => void;
  [x: string]: any;
}

const useStyles = makeStyles(() => ({
  buttonAdded: {
    "backgroundColor": colors.white,
    "border": "1px dashed black",
    "fontWeight": "bold",
    "color": colors.darkGrey,
    "width": "130px",
    "&.MuiButton-fullWidth": {
      width: "100%"
    }
  },
  button: {
    "fontWeight": "bold",
    "width": "130px",
    "&.MuiButton-fullWidth": {
      width: "100%"
    }
  },
  icon: {
    verticalAlign: "sub"
  }
}));
